import React, { useMemo } from "react";
import { IconOrquestador } from "./Icons";
import { BiMessageSquareDetail } from "react-icons/bi";
import { CgScreen } from "react-icons/cg";
import { RiLayout2Line } from "react-icons/ri";
import { PiPuzzlePieceBold } from "react-icons/pi";
import { PiCubeBold } from "react-icons/pi";
import { RiFileUnknowLine } from "react-icons/ri";


export const FileIcon = ({type, style, method, templateType}) => {

  const icon = useMemo(()=>{
    const icons = iconsFn(style);
    const icon = icons[`${type}_${(method || templateType || "")}`];
    return icon && icon();
  }, [type, style, method, templateType]);

  return (
    <>
      {icon}
    </>
  );
};

const iconsFn = (style) => ({
  "template_DIALOGO": () => <BiMessageSquareDetail style={style} color="rgb(255, 163, 69)" />,
  "template_PAGINA":  () => <CgScreen color="#53ffee" style={style}/>,
  "template_RAIZ":    () => <RiLayout2Line color="#bd4343" style={style}/>,
  "template_CAMPO":   () => <PiPuzzlePieceBold color="rgb(43 245 43)" style={style}/>,
  "template_":        () => <RiFileUnknowLine color="grey" style={style}/>,
  "primitiva_GET":    () => <PiCubeBold style={style} color="#009999"/>,
  "primitiva_POST":   () => <PiCubeBold style={style} color="#dc5657"/>,
  "primitiva_PUT":    () => <PiCubeBold style={style} color="#dc5657"/>,
  "primitiva_DELETE": () => <PiCubeBold style={style} color="#dc5657"/>,
  "primitiva_":       () => <PiCubeBold style={style} color="grey"/>,
  "operacion_":       () => <IconOrquestador style={style}/>
})
